"use client";

import React from 'react';
import { FeatherStar } from '@subframe/core';

interface AnimatedStarProps {
  className?: string;
}

/**
 * Animated star icon with a golden shimmer effect
 */
export const AnimatedStar: React.FC<AnimatedStarProps> = ({ className = '' }) => {
  return (
    <span className={`inline-flex relative ${className}`}>
      <style>{`
        @keyframes star-shimmer {
          0%, 100% {
            opacity: 1;
            filter: drop-shadow(0 0 0px #eab308);
            transform: scale(1);
          }
          50% {
            opacity: 1;
            filter: drop-shadow(0 0 5px #eab308) drop-shadow(0 0 10px #facc15);
            transform: scale(1.05);
          }
        }
        .star-icon {
          animation: star-shimmer 2s ease-in-out infinite;
        }
      `}</style>
      <FeatherStar className="star-icon text-yellow-500 fill-yellow-200" />
    </span>
  );
};
